import { setTheme } from "theme/default/setTheme";

export const setFontSize_10px = setTheme(({ theme }) => `font-size: ${theme.fontSize.font_size_10px}`);
